<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { useTeams } from '@/composables/core/teams'
import { useRouter } from 'vue-router'
import DetailsViewLayout from '../layouts/DetailsViewLayout.vue'

const router = useRouter()

const { getUserTeamInvitationsQuery, manageTeamInvitationMutation } = useTeams()

const { isError, isRefetching, isPending, data, error, refetch } = getUserTeamInvitationsQuery()

const handleAcceptInvitation = (invitationID: number) => {
  const form = {
    invitationID: invitationID,
    accept: true,
  }
  manageTeamInvitationMutation.mutate(form, {
    onSuccess: () => {
      router.push({ name: 'teams' })
    },
  })
}

const handleRejectInvitation = (invitationID: number) => {
  const form = {
    invitationID: invitationID,
    accept: false,
  }
  manageTeamInvitationMutation.mutate(form)
}
</script>

<template>
  <DetailsViewLayout back-button-text="Back to previous screen" title="Team Invitations" @on-back-click="router.back()">
    <rl-error-result v-if="isError && !isRefetching" :error="error">
      <el-button @click="refetch()">
        <Icon icon="material-symbols:refresh-rounded" height="16" width="16" :inline="true" />&nbsp;Reload
      </el-button>
    </rl-error-result>
    <template v-else>
      <el-table v-loading="isPending" :data="data" stripe>
        <el-table-column prop="team.name" label="Team" />
        <el-table-column prop="invited_by" label="Invited By" />
        <el-table-column>
          <template #default="scope">
            <div class="flex gap-1">
              <el-button title="Accept" link @click="handleAcceptInvitation(scope.row.id)">
                <Icon icon="material-symbols:check-rounded" inline height="20" />
              </el-button>
              <el-button title="Reject" link @click="handleRejectInvitation(scope.row.id)">
                <Icon icon="material-symbols:delete-outline-rounded" inline height="20" />
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </DetailsViewLayout>
</template>
